import React, {useState, useEffect} from 'react'

function FonctionDisplayKey() {

    const [KeyCode, setKeyCode] = useState('')

    const handleKeyCode = e => {
    
        setKeyCode(e.code)
    }

    useEffect(() =>{
        document.addEventListener("keyup", handleKeyCode)
        return() =>{
            document.removeEventListener("keyup", handleKeyCode)
        }
    }, [])

    return (
        <div className="card">
        <div className="card-body">
            <h1 className="text-center">{KeyCode}</h1>
        </div>
    </div>
    )
}

export default FonctionDisplayKey
